module.exports = __webpack_public_path__ + "img/1f9e2.23d9841.svg";